import React from "react";

import { ColumnDef } from "@tanstack/react-table";
import dayjs from "dayjs";

import { DeleteButton } from "@/components/refine-ui/buttons/delete";
import { EditButton } from "@/components/refine-ui/buttons/edit";
import { Badge } from "@/components/ui/badge";
import { makeTooltip } from "@/components/ui/tooltip";
import type { TagRuleRead } from "@/types/tina";

export const useTagRulesColumns = () => {
  return React.useMemo<ColumnDef<TagRuleRead>[]>(
    () => [
      {
        id: "tag_name",
        accessorKey: "tag_name",
        header: "Tag",
        cell: ({ row }) => (
          <span className="font-medium">{row.original.tag_name}</span>
        ),
        enableColumnFilter: false,
      },
      {
        id: "explanation",
        accessorKey: "explanation",
        header: "Explanation",
        cell: ({ row }) =>
          makeTooltip(
            <div className="max-w-[420px] truncate text-muted-foreground text-sm">
              {row.original.explanation}
            </div>,
            row.original.explanation,
          ),
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        id: "enabled",
        accessorKey: "enabled",
        header: "Enabled",
        cell: ({ row }) =>
          row.original.enabled ? (
            <Badge variant="secondary">Enabled</Badge>
          ) : (
            <Badge variant="outline">Disabled</Badge>
          ),
        enableColumnFilter: false,
      },
      {
        id: "updated_at",
        accessorKey: "updated_at",
        header: "Updated",
        accessorFn: (row) => dayjs(row.updated_at),
        cell: function render({ getValue }: any) {
          return makeTooltip(
            getValue().format("DD/MM/YYYY HH:mm"),
            getValue().format("ddd, MMM D, YYYY HH:mm"),
          );
        },
        enableColumnFilter: false,
      },
      {
        id: "actions",
        size: 120,
        header: "Actions",
        cell: ({ row }) => (
          <div className="flex items-center gap-1">
            <EditButton
              size="sm"
              hideText
              recordItemId={row.original.id}
              resource="tina-tag-rules"
            />
            <DeleteButton
              resource="tina-tag-rules"
              id={row.original.id}
            />
          </div>
        ),
        enableSorting: false,
        enableColumnFilter: false,
      },
    ],
    [],
  );
};
